import { render, staticRenderFns } from "./NoticeboardVersion.vue?vue&type=template&id=54d7a681&scoped=true"
import script from "./NoticeboardVersion.vue?vue&type=script&lang=js"
export * from "./NoticeboardVersion.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardVersion.vue?vue&type=style&index=0&id=54d7a681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7a681",
  null
  
)

export default component.exports